export const main = {
  position: 'relative',
  width: '100%',
  maxWidth: '580px',
  minWidth: '200px',
  height: '42px',
};

export const railStyle = ({ isDisabled }) => ({
  position: 'absolute',
  width: '100%',
  height: '1px',
  marginTop: '20px',
  borderRadius: '5px',
  backgroundColor: !isDisabled ? '#626262' : '#9D9D9D',
});

export const sliderButtonStyle = ({ percent }) => ({
  left: `${percent}%`,
});

export const railOuterStyle = ({ isDisabled }) => {
  return {
    position: 'absolute',
    width: '100%',
    height: '41px',
    marginTop: '20px',
    transform: 'translate(0%, -50%)',
    borderRadius: 7,
    cursor: !isDisabled ? 'pointer' : 'default',
    zIndex: 100,
  };
};

export const sliderTickElementsStyle = ({ tick, isDisabled }) => {
  let marginLeft = '0px';

  if (tick.percent === 100) {
    marginLeft = '-5px';
  }

  return {
    position: 'absolute',
    marginTop: '18px',
    marginLeft,
    width: '5px',
    height: '5px',
    left: `${tick.percent}%`,
    borderRadius: '50%',
    backgroundColor: !isDisabled ? '#626262' : '#9D9D9D',
  };
};
